import React , {useState, useEffect}from 'react';
import ReactDOM from 'react-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DeleteConfirmation = ({ isShowing, hide, rates , deleteBaseDiscount}) => {
  console.log('Rate', rates);
  useEffect(() => {
    
  })
  
  const closePopup = () => {
    hide();
  }

  const deleteBD = ()=> {
    console.log(rates);
    deleteBaseDiscount(rates);
  }

return(
  isShowing?  <div>
  <div className="modal-overlay">
      <div className="modal-wrapper thankyou-popup" aria-modal aria-hidden tabIndex={-1} role="dialog">
        <div className="modal approval">
          <div className="modal-head-cross rate-modal">
            <button type="button" className="modal-close-button" onClick={closePopup}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">

            <div className="editNonFct-header modal-header" >
              <h4 className="popup-head rqst-head fct-head modal-title">Delete Discount</h4>
            </div>
            <div className="approval-content modal-body">
              <div className="popup-container reqst-rejection">
                <p className="reqst-para approval-reqst">Are you sure to delete? </p>
                <div className="confirn-btn">
                    <button className="cancel-reqst" onClick={closePopup}>Cancel</button>
                    <button className="confirm-reqst" onClick={deleteBD}>Proceed</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>:null
)
}

export default DeleteConfirmation;


// WEBPACK FOOTER //
// ./web/components/admin/common/deleteConfirmation.js